import CreateAccountDetail from './CreateAccountDetail'
import CreateAccountForm from './CreateAccountForm'

export default CreateAccountDetail
export { CreateAccountForm }
